import {
  GET_ALL_PERMISSIONS_RESPONSE_SUCCESS,
  CREATE_PERMISSION_NAME,
  API_ERROR,
  EDIT_PERMISSION,
  EDIT_PERMISSION_RESPONSE_SUCCESS,
  GET_ALL_PERMISSIONS,
  DELETE_PERMISSION,
} from "./actionTypes"

export const getAllPermissions = () => {
  return {
    type: GET_ALL_PERMISSIONS,
  }
}
export const getAllPermissionsResponseSuccess = payload => ({
  type: GET_ALL_PERMISSIONS_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createPermission = (payload, toggle) => {
  return {
    type: CREATE_PERMISSION_NAME,
    payload: payload,
    toggle,
  }
}

// ------------------------------------------------------- EDIT ------------------------------------------------------------

export const editPermission = (payload, toggle) => ({
  type: EDIT_PERMISSION,
  payload: payload,
  toggle,
})

export const editPermissionResponse = payload => ({
  type: EDIT_PERMISSION_RESPONSE_SUCCESS,
  payload: payload,
})

export const deletePermission = payload => ({
  type: DELETE_PERMISSION,
  payload: payload,
})
